    <header class="topbar">
      <button type="button" class="icon-btn topbar-toggle" (click)="app.toggleSidebar()"
              aria-label="Toggle navigation">
        <app-icon name="Menu"></app-icon>
      </button>

      <div class="crumbs">
        @for (c of crumbs(); track $index; let i = $index, last = $last) {
          @if (i > 0) {
            <span class="sep"><app-icon name="Chevron" [size]="12"></app-icon></span>
          }
          <span [class.current]="last">{{ c }}</span>
        }
      </div>

      <div class="topbar-spacer"></div>

      <form class="search-pill" [class.busy]="search.searching()" (submit)="onSubmit($event)">
        <app-icon name="Search" [size]="14"></app-icon>
        <input #searchInput type="search" class="search-input"
               [value]="query()" (input)="query.set($any($event.target).value)"
               [placeholder]="'chrome.topbar.searchPlaceholder' | translate"
               [disabled]="search.searching()"
               autocomplete="off" spellcheck="false"
               [attr.aria-label]="'chrome.topbar.searchPlaceholder' | translate" />
        @if (search.searching()) {
          <app-icon class="spin" name="Refresh" [size]="13"></app-icon>
        } @else {
          <kbd>⌘K</kbd>
        }
      </form>

<!--      <div class="role-toggle">-->
<!--        <button type="button" [class.active]="app.role() === 'agent'" (click)="app.setRole('agent')">{{ 'chrome.topbar.roleAgent' | translate }}</button>-->
<!--        <button type="button" [class.active]="app.role() === 'admin'" (click)="app.setRole('admin')">{{ 'chrome.topbar.roleAdmin' | translate }}</button>-->
<!--      </div>-->

      @if (tourKey()) {
        <button type="button" class="icon-btn help-btn" (click)="openTour()" aria-label="Take the tour" title="Take the tour">
          <span class="help-emoji" aria-hidden="true">🧭</span>
        </button>
      }

      @if (helpKey()) {
        <button type="button" class="icon-btn help-btn" (click)="openHelp()" aria-label="Page help" title="Page help">
          <span class="help-emoji" aria-hidden="true">🛟</span>
        </button>
      }

      <!-- No Toolbox button here: the toolbox is a centre-top drop-down whose own pull-tab
           (`.tb-tab`, always visible below the header) opens it. Two triggers for one panel, one
           of them far from the panel it opens, was just noise in the header. -->

      <app-lang-switcher></app-lang-switcher>

      <button type="button" class="icon-btn" (click)="toggleTheme()" [attr.aria-label]="'chrome.topbar.themeToggleAria' | translate">
        @if (app.theme() === 'dark') {
          <app-icon name="Sun"></app-icon>
        } @else {
          <app-icon name="Moon"></app-icon>
        }
      </button>

      <button type="button" class="icon-btn" [attr.aria-label]="'chrome.topbar.notificationsAria' | translate">
        <app-icon name="Bell"></app-icon>
        <span class="dot"></span>
      </button>
    </header>
